import React from "react";
import { Settings } from "lucide-react";

const SettingsScreen = ({
  userData,
  setUserData,
  navigateTo,
  setJobList,
  sampleJobs,
  handleSaveJobPreferences,
}) => {
  const handleSaveAndContinue = async () => {
    // Save both profile and job preferences
    const success = await handleSaveJobPreferences(userData.jobPreferences);

    if (success) {
      // Filter out Hard and Impossible applications - only show Easy/Medium
      const automatableJobs = sampleJobs.filter(
        (job) => job.difficulty === "Easy" || job.difficulty === "Medium",
      );
      setJobList(automatableJobs);
      navigateTo("home");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="flex items-center mb-6">
            <Settings className="w-8 h-8 text-indigo-600 mr-3" />
            <h2 className="applicant-theme-text">Job Preferences</h2>
          </div>

          <div className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Job Types
              </label>
              <div className="grid grid-cols-2 gap-2">
                {["Full-time", "Part-time", "Contract", "Internship"].map(
                  (type) => (
                    <label key={type} className="flex items-center">
                      <input
                        type="checkbox"
                        checked={userData.jobPreferences.jobTypes?.includes(
                          type,
                        )}
                        onChange={(e) => {
                          const types = e.target.checked
                            ? [...userData.jobPreferences.jobTypes, type]
                            : userData.jobPreferences.jobTypes?.filter(
                                (t) => t !== type,
                              );
                          setUserData({
                            ...userData,
                            jobPreferences: {
                              ...userData.jobPreferences,
                              jobTypes: types,
                            },
                          });
                        }}
                        className="rounded border-gray-300 text-indigo-600 mr-2"
                      />
                      <span className="text-sm text-gray-700">{type}</span>
                    </label>
                  ),
                )}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Preferred Locations
              </label>
              <input
                type="text"
                placeholder="e.g., San Francisco, Remote, New York"
                value={userData.jobPreferences.locations.join(", ")}
                onChange={(e) =>
                  setUserData({
                    ...userData,
                    jobPreferences: {
                      ...userData.jobPreferences,
                      locations: e.target.value.split(",").map((l) => l.trim()),
                    },
                  })
                }
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              />
            </div>

            <div>
              <label className="flex items-center">
                <input
                  type="checkbox"
                  checked={userData.jobPreferences.remoteWork}
                  onChange={(e) =>
                    setUserData({
                      ...userData,
                      jobPreferences: {
                        ...userData.jobPreferences,
                        remoteWork: e.target.checked,
                      },
                    })
                  }
                  className="rounded border-gray-300 text-indigo-600 mr-2"
                />
                <span className="text-sm text-gray-700">
                  Open to remote work
                </span>
              </label>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Min Salary
                </label>
                <input
                  type="number"
                  placeholder="50000"
                  value={userData.jobPreferences.salaryRange.min}
                  onChange={(e) =>
                    setUserData({
                      ...userData,
                      jobPreferences: {
                        ...userData.jobPreferences,
                        salaryRange: {
                          ...userData.jobPreferences.salaryRange,
                          min: e.target.value,
                        },
                      },
                    })
                  }
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Max Salary
                </label>
                <input
                  type="number"
                  placeholder="150000"
                  value={userData.jobPreferences.salaryRange.max}
                  onChange={(e) =>
                    setUserData({
                      ...userData,
                      jobPreferences: {
                        ...userData.jobPreferences,
                        salaryRange: {
                          ...userData.jobPreferences.salaryRange,
                          max: e.target.value,
                        },
                      },
                    })
                  }
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                />
              </div>
            </div>
          </div>

          <div className="buttons-container">
            <button onClick={handleSaveAndContinue} className="buttons-green">
              Save & Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsScreen;
